module.exports = __webpack_public_path__ + "img/title-.114f7fbd.png";